<template>
  <div class="card-body px-0 pt-0 pb-3">
    <div class="table-responsive">
      <el-table border :data="expenses" class="el-table-css" style="width: 100%" show-summary :summary-method="getTableSummary"
        size="default">
        <el-table-column label="Tarix" width="110">
          <template #default="scope">
            {{ formatDate(scope.row.expenseDate) }}
          </template>
        </el-table-column>
        <el-table-column prop="reasonName" label="Səbəb" width="230"></el-table-column>
        <el-table-column label="Məbləğ (AZN)" width="140">
          <template #default="scope">
            {{ formatAmount(scope.row.amount) }}
          </template>
        </el-table-column>
        <el-table-column prop="note" label="Qeydlər" />
        <el-table-column width="80" fixed="right">
          <template #default="scope">
              <el-button class="fs-5" type="text" style="padding: 0px;" :disabled="status === 50" :icon="Edit"
                title="Düzəliş et" @click="$emit('edit-expense', scope.row)">
              </el-button>
              <el-button class="fs-5" type="danger" style="padding: 0 !important;" :icon="Delete" title="Sil"
                :disabled="status === 50" text @click="$emit('delete-expense', scope.row.id)">
              </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { Edit, Delete } from "@element-plus/icons-vue";
export default {
  props: {
    expenses: {
      type: Array,
      required: true,
    },
    reasonList: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    status: Number,
  },
  data() {
    return {
      Edit,
      Delete,
    };
  },
  methods: {
    formatDate(date) {
      if (!date) return "-";
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();
      return `${day}.${month}.${year}`;
    },
    formatAmount(value) {
      if (value == null) return "-";
      let parts = Number(value).toFixed(2).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      return parts.join(',');
    },
    getTableSummary({ columns, data }) {
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = 'Cəmi';
        } else if (
          column.label === 'Məbləğ (AZN)' ||
          column.property === 'amount'
        ) {
          const total = data.reduce((sum, row) => sum + Number(row.amount || 0), 0);
          sums[index] = this.formatAmount(total);
        } else {
          sums[index] = '';
        }
      });
      return sums;
    }
  }
};
</script>

<style scoped>
.action-buttons {
  display: flex;
  align-items: center;
}
:deep(.el-table__footer td) {
  font-weight: bold !important;
}
</style>
